<template>
  <v-dialog v-model="dialog" @keydown.esc="cancel" persistent>
    <v-card>
      <v-card-title>
        <span class="headline">ライフライン状況の詳細</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col
              cols="12"
              sm="3"
              md="3"
              lg="3"
              v-for="(label, key, index) in lifelines"
              :key="index"
            >
              <v-text-field
                :label="label"
                :placeholder="config.PLACEHOLDER_SP"
                disabled
                :value="$facility.lifelineStatusName($data['item'], key)"
              >
              </v-text-field>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="mx-2" color="primary" @click.native="cancel">
          戻る
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import Vue from "vue";
import config from "@/js/const";
import Facility from "@/plugins/facility";
Vue.use(Facility);
export default {
  data: () => ({
    config: config,
    dialog: false,
    resolve: null,
    reject: null,
    item: {
      electricity: null,
      gas: null,
      water_supply: null,
      phone: null
    },
    options: {
      lifelineStatuses: []
    },
    lifelines: {
      electricity: "電気",
      gas: "ガス",
      water_supply: "水道",
      phone: "電話"
    }
  }),
  methods: {
    open(item, options) {
      this.dialog = true;
      this.item = item;
      this.options = Object.assign(this.options, options);
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    cancel() {
      this.resolve(false);
      this.dialog = false;
    }
  }
};
</script>
